import Auth from '../auth/Auth';
import AdminRole from "../models/AdminRole";
import { WebClient } from './WebClient'

class ApiAdminRole extends WebClient {
    async getAdminRoles(): Promise<AdminRole[]> {
        const url = "/adminusers/role";

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data || [];
            }
            return [];
        }).catch(() => { return []; });
    }
}

export default new ApiAdminRole();
